export const createClinic = {
    "formType": 'createClinic',
    "title": 'Реєстрація',
    "dataType": 'createClinic',
    "fields": [
        {
            "id": 1,
            "type": 'text',
            "name": 'name',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": 'Назва закладу',
                    "type": 'text',
                    "placeholder": 'Лікарня Номер 1'
                }
            ]
        },
        {
            "id": 2,
            "type": 'number',
            "name": 'edrpou',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": 'Реквізити ЄДРПОУ ',
                    "type": 'number',
                    "placeholder": '12345678'
                }
            ]
        }, {
            "id": 3,
            "type": 'text',
            "name": 'city',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": 'Місто',
                    "type": 'text',
                    "placeholder": 'Львів',

                }
            ]
        }, {
            "id": 4,
            "type": 'text',
            "name": 'medicalDirector',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": 'Директор медичного закладу',
                    "type": 'text',
                    "placeholder": 'Антонов Ігор Миколайович'
                }
            ]
        },
        {
            "legend": 'Лікарі закладу',
            "id": 5,
            "type": 'text',
            "required": false,
            "name": 'attendingDoctors',
            "dataType": 'attendingDoctors',
            "options": true,
            "props": [

            ]
        },
        {
            "legend": 'Відділення',
            "id": 6,
            "type": 'text',
            "required": false,
            "name": 'departments',
            "dataType": 'departments',
            "options": true,
            "props": [

            ]
        },
    ],
    "button": 'Створити',
    "class": 'form__box__login'
}
